import React from 'react';
import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { CountryAutocomplete } from '../../inputs';
import { Destination } from '../../../models/tenant';
import { CountryCode } from '../../../models/country';


export interface ExclusionRowProps {
  destination: Destination;
  onCountryChange: (code: CountryCode) => void;
  onCodesChange: (codes: string[]) => void;
  onRemove: () => void;
}

const ExclusionRow: React.FC<ExclusionRowProps> = ({
  destination,
  onCountryChange,
  onCodesChange,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
      <CountryAutocomplete value={destination.country} onChange={onCountryChange} />
      <TextField
        label={t('Postal Codes')}
        placeholder="VNO, LTU, etc."
        value={destination.codes?.join(',') ?? ''}
        onChange={(e) => onCodesChange(e.target.value.split(','))}
        onBlur={(e) => onCodesChange(e.target.value.split(',').map(c => c.trim()).filter(c => c.length > 0))}
        sx={{ flex: 1 }}
        size="small"
      />
      <Tooltip title={t('Remove exclusion')}>
        <IconButton onClick={onRemove} color="error" size="small" disableRipple>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ExclusionRow;
